/** MediaRecorder timeslice, shared by the recording screen and the upload page's duration estimate. */
const CAPTURE_TIMESLICE_MS = 5000;

export default CAPTURE_TIMESLICE_MS;
